import IndicesRevisionResultatController from './indices.revision.resultat.controller';

export default {
    template: require('./indices.revision.resultat.html'),
    controller: IndicesRevisionResultatController
};
